import React from "react";
import { Telegram } from "@mui/icons-material";
import { motion } from "framer-motion";
import SlideBox from "../versatile/SlideBox";
import AboutCardMatrix from "../AboutCardMatrix";

const Collaboration = () => {
  const data = [
    {
      headline: "Collaboration",
      icon: <Telegram fontSize="large" />, 
      paragraphs: [
        "Shill us any idea we will look into it.",
        "Every idea is good. Even a bad one will make you explain why not to go in some direction.",
      ],
      buttonContent: {
        Text: "Contact Us",
        Href: "https://t.me/mushroom_adv", 
        Target: "_blank",
        Rel: "noopener noreferrer",
      },
    },
  ];

  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.8 } },
  };

  const texts = [
    `> Will be hapy to respond your request.
  
> Feel free to reach out.
  
> It's all about working together to build something gud and reliable.  
  
> Lets build something`,
  ];

  return (
    <motion.div
      style={{
        gridColumn: "3 / span 12",
        gridRow: "5 / span 14",
        padding: window.innerWidth < 1600 && window.innerHeight < 900 ? "0.5rem" : "2rem",
        transition: "all 0.3s ease",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
      }}
      variants={fadeIn}
      initial="hidden"
      animate="visible"
    >
      <div style={{ flex: 1, marginRight: "1rem" }}>
        <SlideBox data={data} buttonContent={data[0].buttonContent} />
      </div>
      <div style={{ flex: 2 }}>
        <AboutCardMatrix texts={texts} speed={100} />
      </div>
    </motion.div>
  );
};

export default Collaboration;
